import { render, staticRenderFns } from "./PropertyWidget.global.vue?vue&type=template&id=42290dc2&scoped=true&lang=pug&"
import script from "./PropertyWidget.global.vue?vue&type=script&lang=ts&"
export * from "./PropertyWidget.global.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyWidget.global.vue?vue&type=style&index=0&id=42290dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42290dc2",
  null
  
)

export default component.exports